import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthContext'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Clients from './pages/Clients'
import ClientProfile from './pages/ClientProfile'
import NewClient from './pages/NewClient'
import Orders from './pages/Orders'
import OrderDetail from './pages/OrderDetail'
import NewOrder from './pages/NewOrder'
import ScanOrder from './pages/ScanOrder'
import QuickInvoice from './pages/QuickInvoice'
import Fabrics from './pages/Fabrics'
import NewFabric from './pages/NewFabric'
import Invoices from './pages/Invoices'
import NewInvoice from './pages/NewInvoice'
import Layout from './components/Layout'
import './App.css'

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth()
  if (loading) return <div className="splash"><div className="splash-logo">J</div></div>
  if (!user) return <Navigate to="/login" replace />
  return children
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="clients" element={<Clients />} />
            <Route path="clients/new" element={<NewClient />} />
            <Route path="clients/:id" element={<ClientProfile />} />
            <Route path="orders" element={<Orders />} />
            <Route path="orders/new" element={<NewOrder />} />
            <Route path="orders/scan" element={<ScanOrder />} />
            <Route path="orders/:id" element={<OrderDetail />} />
            <Route path="invoices/quick" element={<QuickInvoice />} />
            <Route path="fabrics" element={<Fabrics />} />
            <Route path="fabrics/new" element={<NewFabric />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="invoices/new" element={<NewInvoice />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
